import React, { useState } from 'react';

import { PrimaryNavView } from '@futrli/views/views/nav/PrimaryNavView/PrimaryNavView';
import { WorkspaceSettingsSidebar } from '@futrli/predict-next/workspaces/workspaces-list/sidebars/workspace-settings-sidebar/workspace-settings-sidebar';

import { HelpList } from '../../components/mobile/help-list/help-list';
import { MobileMenuDrawer } from '../../components/mobile/mobile-menu-drawer/mobile-menu-drawer';
import { MobileNavBarScaffold } from '../../components/mobile/mobile-nav-scaffold/mobile-nav-scaffold';
import { SettingsMenu } from '../../components/mobile/settings-menu/settings-menu';

export const PrimaryNavMobile = ({ view }: { view: PrimaryNavView }) => {
  const { flags, workspace } = view.state;
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  if (!workspace) {
    return <MobileNavBarScaffold />;
  }

  return (
    <>
      <MobileNavBarScaffold
        left={null}
        right={
          <MobileMenuDrawer
            menuItems={[
              <SettingsMenu
                key="settings"
                workspaceId={workspace.id}
                hasMembersPermission={flags.hasMembersPermission}
                handleSettingsClick={() => setIsSettingsOpen(true)}
              />,
              <HelpList key="help" />
            ]}
          />
        }
      />
      {isSettingsOpen && (
        <WorkspaceSettingsSidebar isOpen onClose={() => setIsSettingsOpen(false)} workspaceId={workspace.id} />
      )}
    </>
  );
};
